import { render, staticRenderFns } from "./DepositYields.vue?vue&type=template&id=e79ce18a&scoped=true"
import script from "./DepositYields.vue?vue&type=script&lang=js"
export * from "./DepositYields.vue?vue&type=script&lang=js"
import style0 from "./DepositYields.vue?vue&type=style&index=0&id=e79ce18a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79ce18a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
